const loaderClassName = 'initial-loader'
let isLoaderHidden = false

export default () => {
  if (isLoaderHidden) {
    return
  }

  new Promise((resolve) => {
    setTimeout(() => {
      document.getElementsByClassName(loaderClassName)[0].style.opacity = 0
      resolve()
    }, 300)
  }).then(() => {
    setTimeout(() => {
      document.getElementsByClassName(loaderClassName)[0].remove()
      isLoaderHidden = true
    }, 550)
  })
}
